import styled from 'styled-components';
import { Card, Form, Typography } from 'antd';
import { HeartFilled } from '@ant-design/icons';

const { Title, Text } = Typography;

export const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #000000 100%);
  padding: 20px;
`;

export const LoginCard = styled(Card)`
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  
  .ant-card-body {
    padding: 40px;
  }
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    margin-bottom: 24px;
  }
  
  .ant-input {
    height: 48px;
    border-radius: 8px;
    font-size: 16px;
  }
  
  .ant-btn {
    height: 48px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const LoginHeader = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const Logo = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  border-radius: 8px;
`;

export const BeatingHeart = styled(HeartFilled)`
  font-size: 48px;
  color: #1a1a1a;
  display: block;
  margin: 0 auto 20px auto;
  animation: heartbeat 1.5s infinite;
  
  @keyframes heartbeat {
    0% { 
      transform: scale(1);
      opacity: 1;
    }
    50% { 
      transform: scale(1.2);
      opacity: 0.8;
    }
    100% { 
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const StyledTitle = styled(Title)`
  &&& {
    margin: 0;
    color: #333;
  }
`;

export const StyledAlert = styled.div`
  margin-bottom: 24px;
`;

export const SignInButton = styled.div`
  .ant-btn {
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 50%, #000000 100%);
    border: none;
  }
`;

export const FooterText = styled.div`
  text-align: center;
  margin-top: 16px;
`;

export const CopyrightText = styled(Text)`
  &&& {
    font-size: 12px;
  }
`;
